import Swiper from "swiper";
import {Autoplay, Navigation} from "swiper/modules";
import {getOptionsFromJsonString} from "cronus-theme/default/global/js/utilities/options";

export function initSlideTextslider(wrapper = document) {
    for(const slider of wrapper.querySelectorAll('.js-dcSlidetextslider')) {
        const options = getOptionsFromJsonString(slider.dataset.options, {
            autoplay_interval: 5000,
            eff_interval: 300,
        });
        new Swiper(slider,{
            modules: [Navigation,Autoplay],
            slidesPerView: 1,
            watchSlidesProgress: true,
            speed: options.eff_interval,
            autoplay: options.autoplay_interval > 0
                ? { delay: options.autoplay_interval }
                : false,
            navigation: {
                nextEl: slider.parentElement.querySelector('.swiper-button-next'),
                prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
            }
        });
    }
}